module.exports = __webpack_public_path__ + "static/assets/4d3c44e440a7d664dd4dbb11c1413f21.png";